import React from 'react';
import { Translate } from 'react-redux-i18n';
import ScrollComponent from '../../common/ScrollComponent';
import Chart from './chart';
import sizeMe from 'react-sizeme';

class BarChart extends React.Component {
  render() {
    const { componentId, width, currentTab, height } = this.props;

    return (
      <div
        className="ts-chart stock-chart"
        id={`time-and-sale-export-${componentId}`}
      >
        <ScrollComponent appendStyle={{ maxHeight: height }}>
          <div className="chart-title">
            <Translate value="timeAndSale.chartTitle" />
          </div>
          <Chart currentTab={currentTab} width={width - 5} />
        </ScrollComponent>
      </div>
    );
  }
}

export default sizeMe({ monitorHeight: true })(BarChart);
